const BASE_CURRENCY = 'XAF'
const BASE_LOCALE = 'fr-CM'
const ZERO_DECIMAL_CURRENCIES = new Set(['XAF', 'XOF'])

const toNumber = (value, fallback = 0) => {
  const number = Number(value)
  return Number.isFinite(number) ? number : fallback
}

export function normalizeCurrencyCode(currency) {
  return currency?.toUpperCase?.() || BASE_CURRENCY
}

export function normalizeExchangeRate(exchangeRate) {
  const normalized = Number(exchangeRate)
  return Number.isFinite(normalized) && normalized > 0 ? normalized : 1
}

export function convertFromBaseCurrency(amount, exchangeRate = 1) {
  return toNumber(amount) * normalizeExchangeRate(exchangeRate)
}

export function formatCurrencyAmount(amount, { currency = BASE_CURRENCY, locale = 'fr-FR' } = {}) {
  const normalizedCurrency = normalizeCurrencyCode(currency)
  const usesZeroDecimals = ZERO_DECIMAL_CURRENCIES.has(normalizedCurrency)

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: normalizedCurrency,
    minimumFractionDigits: usesZeroDecimals ? 0 : 2,
    maximumFractionDigits: usesZeroDecimals ? 0 : 2,
  }).format(toNumber(amount))
}

export function formatBasePrice(amount) {
  return formatCurrencyAmount(amount, {
    currency: BASE_CURRENCY,
    locale: BASE_LOCALE,
  })
}

export { BASE_CURRENCY }
